import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ConfirmDeliveryParams } from "../../../domain/repos/delivery-repo";
import { type DeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const confirmDelivery = createAsyncThunk<
  void,
  ConfirmDeliveryParams,
  { dispatch: DeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CONFIRM_DELIVERY, async (params, { extra }) => {
  await extra.deliveryRepo.confirmDelivery(params);
});
